module.exports = __webpack_public_path__ + "img/2.6994b6a9.png";